import type { CollectionSummaryJSONObject } from '@ikegps/core-api';
import { CollectionModel } from '../../collection.data';

export interface CollectionProvider {
	getCollections(): CollectionSummaryJSONObject[];
	getCollectionIds(): string[];
}

export class CollectionProviderHelpers {
	static isCollectionProvider(c): c is CollectionProvider {
		return typeof c.getCollections === 'function';
	}

	static getCollections(c: CollectionModel): CollectionSummaryJSONObject[] {
		const collections: CollectionSummaryJSONObject[] = [];

		c.forEachField((field) => {
			if (!CollectionProviderHelpers.isCollectionProvider(field)) {
				return;
			}

			const fieldCaptures = field.getCollections() || [];
			for (const fieldCapture of fieldCaptures) {
				collections.push(fieldCapture);
			}
		});

		return collections;
	}

	static getCollectionIds(c: CollectionModel): string[] {
		const collections: string[] = [];

		c.forEachField((field) => {
			if (!CollectionProviderHelpers.isCollectionProvider(field)) {
				return;
			}

			const fieldCaptures = field.getCollectionIds() || [];
			for (const fieldCapture of fieldCaptures) {
				collections.push(fieldCapture);
			}
		});

		return collections;
	}
}
